<nk-help-popover class="ms-2" [popoverTemplate]="bankruptcyRiskScoreHelpInfo"></nk-help-popover>

<ng-template #bankruptcyRiskScoreHelpInfo>
  <div class="small" style="max-width: 450px">
    <p [innerHtml]="'bankruptcy_risk_score.help_message' | translate"></p>
    @if (modelKey()) {
      <p class="text-muted">
        {{ 'dashboard.' + modelKey() | translate }}
      </p>
    }
    <ul class="list-unstyled mb-0">
      @for (item of companyRiskScoreGroupingList$ | async; track item.group_key) {
        <li class="d-flex align-items-center mb-1">
          <nk-bankruptcy-risk-score-level-item [groupKey]="item.group_key"></nk-bankruptcy-risk-score-level-item>
          @if (item.from_measure_value !== null || item.to_measure_value !== null) {
            :
          }
          <span class="ms-2 text-nowrap">
            @if (item.from_measure_value !== null && item.to_measure_value !== null) {
              {{ item.from_measure_value | percentage }} &ndash; {{ item.to_measure_value | percentage }}
            } @else if (item.from_measure_value !== null) {
              {{ item.from_measure_value | percentage }}+
            } @else if (item.to_measure_value !== null) {
              &lt; {{ item.to_measure_value | percentage }}
            }
          </span>
        </li>
      }
    </ul>
  </div>
</ng-template>
